<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index" @click="selectItem(item)"
      :class="{ selected: selectedItem && selectedItem.agentId === item.agentId }">
      <div class="title">
        <div class="methodTitle">
          <h3>{{ item.agentName ? item.agentName : '未填写' }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li>
              <h3>SIM卡</h3>
              <p>{{ item.cardQuantity ? item.cardQuantity : '0' }}</p>
            </li>
            <li>
              <h3>手机号</h3>
              <p>{{ item.mobile ? item.mobile : '未填写' }}</p>
            </li>
            <li>
              <h3>注册时间</h3>
              <p>{{ item.createTime }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      selectedItem: null // 记录当前选中的项
    }
  },
  watch: {
    // 监听 list 变化，如果 list 被重置，清空选中项
    list: {
      handler (newList) {
        if (newList && this.selectedItem) {
          // 检查当前选中的项是否还在新列表里，不在则清空
          const exists = newList.some(item => item.agentId === this.selectedItem.agentId)
          if (!exists) {
            this.selectedItem = null
            this.$emit('selection-changed', this.selectedItem)
          }
        }
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    selectItem (item) {
      // 实现单选逻辑，如果点击已选中的项，则取消选中
      if (this.selectedItem && this.selectedItem.agentId === item.agentId) {
        this.selectedItem = null
      } else {
        this.selectedItem = item
      }

      // 触发一个事件，通知父组件选中了哪个项
      this.$emit('selection-changed', this.selectedItem)
    },
    boxBtn (e) {
      this.$router.push({
        name: 'Recharge',
        params: {
          iccid: e
        }
      })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }

  .box {
    width: 690px;
    height: 220px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 40px 20px;
    cursor: pointer;
    /* 添加光标样式表示可点击 */

    &:active {
      /* 添加点击反馈 */
      opacity: 0.85;
    }

    &.selected {
      /* 选中状态的样式 */
      box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 15%), 0 0 0 3px #07c160;
      /* 示例：添加蓝色边框 */
      background-color: #f8f9ff;
      /* 示例：改变背景色 */
    }

    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .methodTitle {
        display: flex;
        justify-content: space-between;

        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
      }

      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 70px;

          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }

            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }

    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;

      .van-button {
        width: 100px;
      }
    }
  }

  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
</style>
